import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  root: {
    background: 'white',
    padding: 16,
    boxShadow: '0 1px 12px rgba(0,0,0,0.24)',
    width: 200,
    borderRadius: 3,
    position: 'absolute',
    left: 16 - 100,
    top: -124,
    transition: '200ms',
    zIndex: 999,
    opacity: 1,
    transform: 'translate3d(0,0,0)'
  },
  driverImg: {
    height: 48,
    width: 48,
    marginBottom: 12,
    borderRadius: 4,
    boxShadow: '0 1px 12px rgba(0,0,0,0.12)'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/map-markers/driver-card-styles.js